import React from "react";
import { useDropzone } from "react-dropzone";
import styles from "./dropzone.module.scss";
import { Flex, Space, Form } from "antd";
import { InboxOutlined, PaperClipOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTypography from "../common/CustomTypography";
import { setExtractedData } from "../../store/reducers/slices/extractedData.slice";
import { useDispatch, useSelector } from "react-redux";

const Dropzone = ({ showIcon = true, form, isEdit, setCurrentFiles, setFiles, mapIndex, reset, remove, name, iconStyle = {}, iconClass, titleStyle = {}, subtitleStyle = {}, showSubtitle = false, showTitle = true, handleSampleDownload = () => { }, title = "Drop Bank Statement to upload, or browse", files = [], handleDrop = () => { }, multiple = false, ...rest }) => {
    const { getRootProps, getInputProps, } = useDropzone({
        onDrop: handleDrop,
        multiple: multiple,
    });

    let dispatch = useDispatch();





    // const dispatch = useDispatch();
    const { extractedData } = useSelector(({ extractedData }) => extractedData);
    const { uploadedAccountDetails } = useSelector(({ updateReport }) => updateReport);
    console.log('extData', extractedData);
    // const [form] = Form.useForm();
    const bankAccountss = form.getFieldValue('bankAccounts') || [];
    console.log("Outer Delete clicked", files, bankAccountss, mapIndex);
    const uploadFile = uploadedAccountDetails?.reportAccounts[mapIndex]?.files || [];

    let isDropzoneDisabled = uploadFile.length === 0 ? false : true;

    console.log("OUTERTHREAD FILE UPLOAD::", uploadFile, uploadedAccountDetails);


    const handleDelete = (fileIndex) => {
        const bankAccounts = form.getFieldValue('bankAccounts') || [];
        console.log("Delete clicked", files, bankAccounts);

        if (bankAccounts[mapIndex]) {

            console.log(extractedData, "extractedData")

            // if (extractedData.length === 1) {
            //     console.log("set blank array")
            //     dispatch(setExtractedData([]))
            // } else {
            let FindIndex = extractedData.findIndex((iteratore) => iteratore?.mapIndex === mapIndex);
            console.log("FIND INDEX OF ARRAY", FindIndex);

            if (FindIndex >= 0) {
                let _extractedData = [...extractedData];
                if (_extractedData[FindIndex].uploadedFiles.length > 1) {
                    const newUploadedFiles = _extractedData[FindIndex].uploadedFiles.filter((item) => item.name !== files.acceptedFiles[fileIndex].name)
                    _extractedData[FindIndex] = {
                        ..._extractedData[FindIndex],
                        uploadedFiles: newUploadedFiles,
                    };
                } else if (_extractedData[FindIndex].uploadedFiles.length === 1) {
                    _extractedData = _extractedData.filter((item, index) => index !== FindIndex)
                    const updatedAccount = {
                        reportName: bankAccounts[mapIndex].reportName,
                        createdBy: bankAccounts[mapIndex].createdBy,
                        createdOn: bankAccounts[mapIndex].createdOn,
                        ...Object.fromEntries(
                            Object.keys(bankAccounts[mapIndex])
                                .filter(key => key !== 'createdBy' && key !== 'createdOn' && key !== 'reportName')
                                .map(key => [key, null])
                        )
                    };
                    bankAccounts[mapIndex] = updatedAccount;
                }
                // let newextractedData = extractedData[FindIndex].splice(FindIndex, 1);
                console.log("NEW EXTRACTED DATA FIND INDEX", _extractedData);
                dispatch(setExtractedData(_extractedData))
            }
            // }

            setFiles((prev) => {
                return ({
                    ...prev,
                    acceptedFiles: prev.acceptedFiles.filter((item, index) => index !== fileIndex)
                })
            })

            setCurrentFiles((prev) => {
                return prev.filter((item, index) => index !== fileIndex)
            })
        }
        console.log("Delete clicked", files, bankAccounts);
        form.setFieldsValue({ bankAccounts });
        // setFiles([])
        // setCurrentFiles([]);
    }

    console.log('files', files);


    const getFile = () => {
        console.log("files", files);
        return (
            files?.acceptedFiles?.length > 0 ? (
                files?.acceptedFiles?.map((file, index) => {
                    return (
                        <Flex className="pt-8" gap={3} key={index}>
                            <PaperClipOutlined style={{ fontSize: "18px" }} />
                            <Space>
                                <CustomTypography
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        lineHeight: "22px",
                                        color: "#1677FF",
                                        fontFamily: "Satoshi"
                                    }}
                                >
                                    {file?.file?.name}
                                </CustomTypography>

                                <DeleteOutlined style={{ color: '#fa0205' }} onClick={() => handleDelete(index)} />
                            </Space>
                        </Flex>
                    )
                })
            ) : (
                <Flex className="pt-8" gap={3}>
                    <PaperClipOutlined style={{ fontSize: "18px" }} />
                    <CustomTypography
                        style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "22px",
                            color: "#1677FF",
                            fontFamily: "Satoshi"
                        }}
                    >
                        No files uploaded
                    </CustomTypography>
                </Flex>
            )
        );
    };



    return (
        <>
            <section style={{ cursor: 'pointer' }} className={styles.container}>
                <div  {...getRootProps({ className: 'dropzone' })}>
                    <Flex vertical justify="center" align="center">
                        <input {...getInputProps()} />
                        {
                            showIcon && <p className={iconClass}>
                                <InboxOutlined style={{ ...iconStyle, fontSize: '48px', color: '#1890ff' }} />
                            </p>
                        }
                        {
                            showTitle && <CustomTypography style={{ ...titleStyle, fontSize: '16px', fontWeight: 400, lineHeight: "24px", color: '#000000E0', textAlign: 'center' }}>{title}</CustomTypography>
                        }
                        {
                            showSubtitle && <CustomTypography style={{ ...subtitleStyle, fontWeight: 400, fontSize: '14px', lineHeight: "22px", color: '#00000073', textAlign: 'center', paddingTop: "8px" }}>Click <span onClick={(e) => {
                                e.stopPropagation();
                                handleSampleDownload();
                            }
                            }
                                style={{ color: "#1677FF", textDecoration: "underline", paddingRight: "3px", cursor: "pointer" }}
                            >
                                here
                            </span>
                                to download sample statement
                            </CustomTypography>
                        }
                    </Flex>
                </div>
            </section>
            {/* <>
                {
                    uploadFile.map((item, index) => (
                        <Flex className="pt-8" gap={3} key={index}>
                            <PaperClipOutlined style={{ fontSize: "18px" }} />
                            <Space>
                                <CustomTypography
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        lineHeight: "22px",
                                        color: "#1677FF",
                                        fontFamily: "Satoshi"
                                    }}
                                >{item.originalName}</CustomTypography>
                                <DeleteOutlined disabled={true} style={{ color: '#b0acac' }} />
                            </Space>
                        </Flex>
                    ))
                }
            </>
            {
                (Object.keys(files).length > 0) && <div>{getFile()}</div>
            } */}
        </>
    );
};

export default Dropzone;
